module.exports = __webpack_public_path__ + "static/media/person.8ad283b3.svg";